// extracted by mini-css-extract-plugin
module.exports = {"button":"ccfda6eb9f--button--dh5GL"};